export default __webpack_public_path__ + "static/media/SloggerExtension.5c5a7db6.rar";